import * as React from "react";
import * as ReactDOM from "react-dom";


import App from "../components/faqs/App";



const rootEl = document.getElementById("root");
const render = Component => {
    return ReactDOM.render(
        <Component/>,
        rootEl
    );
};

render(App)

// Hot Module Replacement API
declare let module: { hot: any };

if (module.hot) {
    const componentName = "./components/faqs/App"
    module.hot.accept(componentName, () => {
        const NextApp = require(componentName).default;
        render(NextApp);
    });
}
